export const normalizeURL = (url: string, baseUrl: string) =>
  (/\/$/.test(baseUrl) ? baseUrl : baseUrl + '/') +
  (/^\//.test(url) ? url.replace(/^\//, '') : url);
